<template>
  <div>
    <h6 class="mb-3">PPT Upload</h6>
    <b-form-group
      label="PowerPoint file"
      label-for="presentation-ppt-file"
      :state="fileState"
      :invalid-feedback="displayFileError"
    >
      <b-form-file
        id="presentation-ppt-file"
        v-model="localFile"
        name="pptFile"
        accept=".ppt,.pptx"
        placeholder="Choose a PPT or PPTX file"
        browse-text="Browse"
        v-validate="required ? 'required' : ''"
        data-vv-as="PowerPoint file"
        :state="fileState"
        @input="validateSelectedFile"
      ></b-form-file>
    </b-form-group>
    <div v-if="uploadStatus" class="ppt-upload-progress">
      <b-progress
        :value="normalizedUploadProgress"
        :max="100"
        height="8px"
        variant="success"
      ></b-progress>
      <div class="fs-13 text-muted mt-1">
        {{ uploadStatus }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "presentation-ppt-upload-section",
  props: {
    file: {
      type: File,
      default: null,
    },
    uploadStatus: {
      type: String,
      default: "",
    },
    uploadProgress: {
      type: Number,
      default: 0,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localFile: this.file,
      fileError: "",
    };
  },
  computed: {
    fileState() {
      return this.fileError || this.errors.has("pptFile") ? false : null;
    },
    displayFileError() {
      return this.fileError || this.errors.first("pptFile");
    },
    normalizedUploadProgress() {
      const progress = parseFloat(this.uploadProgress);
      if (Number.isNaN(progress)) return 0;
      return Math.min(Math.max(progress, 0), 100);
    },
  },
  watch: {
    file(value) {
      this.localFile = value;
      if (!value) {
        this.fileError = "";
      }
    },
  },
  methods: {
    validateSelectedFile(value) {
      if (!value) {
        this.fileError = "";
        this.$emit("file-selected", null);
        this.$emit("file-invalid", "");
        return;
      }

      const extension = this.getFileExtension(value.name);
      if (!["ppt", "pptx"].includes(extension)) {
        this.fileError = "Only .ppt or .pptx files are allowed.";
        this.localFile = null;
        this.$emit("file-selected", null);
        this.$emit("file-invalid", this.fileError);
        return;
      }

      this.fileError = "";
      this.$emit("file-selected", value);
      this.$emit("file-invalid", "");
    },
    getFileExtension(name) {
      if (!name || !name.includes(".")) return "";
      return name.split(".").pop().toLowerCase();
    },
  },
};
</script>
